<template>
<a href="/#/displayoijsfesljfdsljfdsljfdsijoijfe9840vr0irijf409j409jv09j09j09j4309j4309j4309j309jroijpij9ijfesiuiuesesoijesoijfesoijfesoijojfe"><button>Display</button></a>
<a href="/#/update498494ij4j4949ifi9fjuvrijojsojsoijsonvsoivsoivsoioijvjrjpaoojsfesoifsoifsoijfesoijfeojfeoe8vo8o8jessojejo8eso8jeso8jovsojsjoie"><button>Update</button></a>
</template>

<script>
export default {
  name: 'HomePage'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
